import React, { FC } from "react";
import "./SpinnerField.scss";
import {Loader} from "@surfnet/sds";

export const SpinnerField: FC = () => <Loader/>;

export default SpinnerField;
